<header-share></header-share>
<router-outlet></router-outlet>
<!-- <footer-share #footerShare id="footerWrap" *ngIf="footerShow"></footer-share> -->
